module.exports = __webpack_public_path__ + "fonts/RundigsburgBold.36da391.ttf";